import { render, staticRenderFns } from "./operationSalesStatistics.vue?vue&type=template&id=baa8c77e&scoped=true"
import script from "./operationSalesStatistics.vue?vue&type=script&lang=js"
export * from "./operationSalesStatistics.vue?vue&type=script&lang=js"
import style0 from "./operationSalesStatistics.vue?vue&type=style&index=0&id=baa8c77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa8c77e",
  null
  
)

export default component.exports